var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};

OCS.Viewer.Classes.DebugMapFeature = new Class({
    debug_timeout: null,
    map_debug_controls: null,
    debug_update_time: 10000,
    init_debug_map_events: function () {
        this.addEvent('visual_frame_debug', this.on_visual_frame_debug.bind(this));
        if (this.map_datetime_obj) {
            this.map_datetime_obj.addEvent('time_update', this.on_debug_time_update.bind(this));
        }

    },
    set_debug: function (val) {
        if (val !== this.options.debug) {
            if (val) {
                this.start_debug();
            } else {
                this.stop_debug();
            }
        }
    },
    start_debug: function () {
        this.init_debug_map_events();
        this.options.debug = true;
        this.map_debug_controls = OCS.Viewer.Functions.get_utilities().create_throttled_method(function (e) {
            if (this.ol_object) {
                this.visual_frame_debug();
            }
        }.bind(this), 300, {leading: false});
        this.on_visual_frame_debug();
    },
    stop_debug: function () {
        this.options.debug = false;
        this.map_debug_controls = Function.from;
        if (this.debug_timeout) {
            clearTimeout(this.debug_timeout);
            var container_id = "debug_container_" + this.map_selector;
            var container = jQuery("#" + container_id);
            if (container.length) {
                container.unbind();
                jQuery("#" + container_id + " .frame").unbind();
                container.remove();
            }
        }

    },
    on_debug_time_update: function (time) {
        if (this.options.debug) {
            this.visual_frame_debug();
        }
    },
    visual_frame_debug: function () {
        this.fireEvent('visual_frame_debug', this);
    },
    on_visual_frame_debug: function () {
        if (this.debug_timeout) {
            clearTimeout(this.debug_timeout);
            this.debug_timeout = null;
        }
        if (this.ol_object) {
            if (!window.OCS.ocsmap) {
                window.OCS.ocsmap = {};
            }
            var dateObj = this.get_map_datetime_obj();
            window.OCS.ocsmap[this.map_selector] = this;
            console.log('Visual Frame Debug Activated');
            var container_id = "debug_container_" + this.map_selector;
            var container = jQuery("#" + container_id);
            if (!container.length) {
                container = jQuery('<div class="debug_window" id="' + container_id + '" />');
                container.css({
                    position: 'absolute',
                    left: '10px',
                    minWidth: '300px',
                    bottom: '60px',
                    height: '660px',
                    zIndex: '999999999',
                    background: '#FFFFFF',
                    border: '1px solid #000000',
                    overflow: 'scroll',
                    padding: '10px',
                    fontSize: '8px',
                    fontWeight: 'normal',
                    fontFamily: 'Arial'
                });
                jQuery('body').append(container);
                if (container.draggable) {
                    container.draggable();
                }
            }

            var table = '<table><tr>';
            var endtime = dateObj.get_end_epoch_time();
            var starttime = dateObj.get_frame_from_timestamp(dateObj.get_start_epoch_time());
            var current_time = dateObj.get_current_epoch_time();
            //var current_timestamp = moment(current_time).format('HH:mm');
            var color, time, existing_layer, active_layer;
            Object.each(this.layer_groups, function (grouped_layer) {
                existing_layer = null;
                active_layer = null;
                if ((!grouped_layer.is_static() || this.options.debug_static_layers)) {
                    var column = '<td>' + grouped_layer.get_layer_short_name() + '(' + grouped_layer.get_num_layers() + ') ' + '<br />';
                    for (var i = starttime; i <= endtime; i = i + 60000) {
                        time = moment(i).format('HH:mm');
                        if (i === current_time) {
                            column += '<div class="frame" rel="' + i + '" style="margin: 0px; padding: 1px; line-height: 8px; background: #CECECE; cursor: pointer;">';
                        } else {
                            column += '<div class="frame" rel="' + i + '" style="margin: 0px; padding: 1px; line-height: 8px; cursor: pointer;">';
                        }
                        if (grouped_layer.get_layer_in_step) {
                            existing_layer = grouped_layer.get_layer_in_step(i);
                        } else {
                            if (grouped_layer.get_active_layer) {
                                active_layer = grouped_layer.get_active_layer();
                                if (active_layer && dateObj.is_in_step(i, active_layer.get_timestamp_epoch())) {
                                    existing_layer = active_layer;
                                }
                            }
                        }
                        if (!OCS.Viewer.Live.Utilities.is_undefined(existing_layer) && !OCS.Viewer.Live.Utilities.is_null(existing_layer) && existing_layer) {
                            if (existing_layer.is_ready) {
                                if (existing_layer.is_visible()) {
                                    if (existing_layer.is_drawing_in_background()) {
                                        color = '#FF00CC';
                                    } else {
                                        color = '#FF0000';
                                    }
                                } else {
                                    if (existing_layer.is_drawn()) {
                                        color = '#0000FF';
                                    } else {
                                        color = '#0099FF';
                                    }
                                }
                                column += '<b style="color: ' + color + '">' + time + ' (' + this.get_layer_index(grouped_layer.get_ol_object()) + ') ' + existing_layer.display_debug_data() + '</b>';
                            } else {
                                column += '<b style="color: yellow"> ' + time + ' ' + existing_layer.display_debug_data() + '</b>';
                            }
                        } else {
                            if ((this.options.debug_static_layers && grouped_layer.is_static()) && i === current_time) {
                                existing_layer = grouped_layer.get_active_layer();
                                if (existing_layer) {
                                    column += '<b style="color: red">' + time + ' (' + this.get_layer_index(grouped_layer.get_ol_object()) + ') ' + existing_layer.display_debug_data() + '</b>';
                                } else {
                                    column += time;
                                }
                            } else {
                                column += time;
                            }
                        }

                        column += '</div>';
                    }
                    column += '</td>';
                    table += column;
                }
            }.bind(this));
            table += '</tr></table';
            container.html(table);
        }
        if (!this.debug_timeout) {
            this.debug_timeout = setTimeout(this.visual_frame_debug.bind(this), this.debug_update_time);
        }
    },
});